export default {
  'forgotPass.error.required': 'Please input the required fields',
  'forgotPass.error.invalid.email': 'Please enter a valid email address',
  'forgotPass.title': 'Forgot password',
  'forgotPass.sub.title': 'Enter your registered email address below to reset your password.',
  'forgotPass.form.email': 'Email',
  'forgotPass.form.button.submit': 'Reset password',
};
